export default function BookingCTA() {
  return (
    <section id="book-now" className="bg-blue-600 py-16" data-aos="fade-up">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold text-white mb-4">
          Ready to hit the road?
        </h2>
        <p className="text-blue-100 mb-8">
          Book your perfect ride today and start your journey with confidence.
        </p>
        <a
          href="#contact"
          className="bg-white text-blue-600 px-6 py-3 rounded-md font-medium hover:bg-gray-100 transition duration-300"
        >
          Contact Us
        </a>
      </div>
    </section>
  );
}